export const environment = {
  apiBaseUrl: 'https://franklins-dev-api.co3.xyz',
  loginUrl: 'https://franklins-dev-api.co3.xyz/login',
  production: true,
  // CCC
  apiScope: "api://d378c511-feb8-421a-8382-1d349019e66b/access_as_user",
  azureADClientId: "33c1af22-ae16-4997-b860-0a1c4d2f6bff",
  azureADAuthority: "https://login.microsoftonline.com/94d5dcd7-0550-4a58-aa53-9a50f16a5eac",
  azureADRedirectUri: "https://franklins-dev.co3.xyz/dashboard"
};
